import { Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef } from "@angular/core";
import { AfterViewInit } from "@angular/core";
import * as he from 'he';
import moment from 'moment';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators
} from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { AppConfig } from "../../app.config";
import { DatastoreService } from "../../services/datastore.service";
import { DobValidatorService } from "../../services/dob-validator.service";
import { ApiService } from "../../services/jrni/api.service";
import { AvailabilityService } from "../../services/jrni/availability.service";
import { BasketService } from "../../services/jrni/basket.service";
import { DepartmentService } from "../../services/jrni/department.service";
import { MemberService } from "../../services/jrni/member.service";
import { ServicesService } from "../../services/jrni/services.service";
import { AlertService } from "../../_alert";
import { ConfigService } from "../../services/config.service";
import { confirmPasswordValidator } from "../../validators/confirm-password.validator";
import { passwordValidator } from "../../validators/password.validator"
import { CostBreakdownComponent } from "../../cost-breakdown/cost-breakdown.component";
import { GovukInitService } from '../../services/govuk-init.service';
import { PasswordInput } from 'govuk-frontend';
import { inject } from "@angular/core";

@Component({
  selector: "app-booking-details",
  templateUrl: "./booking-details.component.html",
  styleUrls: ["./booking-details.component.scss"],
})
export class BookingDetailsComponent implements OnInit, AfterViewInit {
  selectedDepartment;
  selectedService;
  pageTitle: string;
  dataPolicy: string;
  tncPolicy: string;
  servicePolicy: string;
  dataPolicyCy: string;
  bookingDetailsPageText: string;
  bookingQuestions = [];
  submitted: boolean;
  selectedLocation;
  requiresFullRegistration = false;
  showBookingQuestions = false;
  organisationQuestions = [];
  today = new Date();
  selectedFile: string;
  selectedId: any;
  subtmitButtonDisabled: boolean;
  addresses = [];
  addressFoundBefore = false;
  member;
  slot;
  banned = false;
  customerQuestions;
  unavailableTimes = [];
  currentYear = new Date().getFullYear();
  // https://regexr.com/3pp3r <- Postcode validator
  postcodeValidator = new RegExp(
    '^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2}))$');
  dateId;
  costBreakDown = [];
  companyQuestions = [];
  searchText: string;
  debounceTimer: any;
  adminJourney: boolean = false;

  @ViewChild('password') passwordCtrl!: ElementRef;

  // Initialise the customer form
  customerDetailsForm: UntypedFormGroup = new UntypedFormGroup({
    first_name: new UntypedFormControl("", Validators.required),
    last_name: new UntypedFormControl("", Validators.required),
    email_address: new UntypedFormControl("", [Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i)]),
    email_address_consent: new UntypedFormControl("", Validators.requiredTrue),
    contact_number: new UntypedFormControl("", [Validators.required, Validators.pattern('^(\\+\\d{1,3}[- ]?)?\\d{11}$')]),
    contact_number_consent: new UntypedFormControl("", Validators.requiredTrue),
    // postcode: new FormControl(""),
    // selectedAddress: new FormControl(""),
    data_policy: new UntypedFormControl('', Validators.requiredTrue),
    tnc: new UntypedFormControl('', Validators.requiredTrue),
    service_policy: new UntypedFormControl('', Validators.requiredTrue),
    dob_day: new UntypedFormControl(false, [Validators.required, Validators.min(1), Validators.max(31)]),
    dob_month: new UntypedFormControl(false, [Validators.required, Validators.min(1), Validators.max(12)]),
    dob_year: new UntypedFormControl(false, Validators.required),
    password: new UntypedFormControl(""),
    copyData: new UntypedFormControl(""),
    // confirm_password: new FormControl('', [Validators.required, confirmPasswordValidator]),
  });
  config: any;

  formBuilder: UntypedFormBuilder = inject(UntypedFormBuilder);
  constructor(
    private router: Router,
    private servicesService: ServicesService,
    private departmentService: DepartmentService,
    private basketservice: BasketService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private memberService: MemberService,
    private datastoreService: DatastoreService,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private availabilityService: AvailabilityService,
    private configService: ConfigService,
    public translate: TranslateService,
    private govuk: GovukInitService,
    private cdref: ChangeDetectorRef,
  ) { }

  companyQuestionsForm: UntypedFormGroup = this.formBuilder.group({});
  bookingQuestionsForm: UntypedFormGroup = this.formBuilder.group({});

  pad(num: number, size: number): string {
    let s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  get form() {
    return this.customerDetailsForm.controls;
  }

  get bookingForm() {
    return this.companyQuestionsForm.controls;
  }

  routerGoBack() {
    this.router.navigate(["/calendar"]);
  }

  restartJourney() {
    this.router.navigate(["/departments"]);
  }


  ngOnInit() {
    this.govuk.init();
    this.scrollToTop();
    console.log('admin', this.datastoreService.adminJourney);
    if (!this.datastoreService.adminJourney) {
      this.adminJourney = false;
      this.customerDetailsForm.controls['password'].setValidators([Validators.required, passwordValidator]);
      console.log(this.customerDetailsForm.controls['password']);
    }
    else {
      this.adminJourney = true;
    }

    // restore the costbreakdown from datastore
    if (this.datastoreService.serviceFees) {
      this.costBreakDown = this.datastoreService.serviceFees;
    } else {
      this.costBreakDown = []; // clear cost breakdown; in future if we add to this more we dont want to clear but replace
    }

    this.availabilityService.getSelectedSlot().then(slot => {
      if (slot) {
        this.slot = slot
      }
    })
    this.departmentService.get().then(async (selectedDepartment) => {
      this.config = await this.configService.getConfig();

      if (selectedDepartment === undefined) {
        this.restartJourney();
      } else {
        this.spinner.show();
        this.selectedDepartment = selectedDepartment;

        let registrationOption = '';
        let organisationQuestionsID;

        // Set the title on the login page to the title from the business question
        this.selectedDepartment.extra?.hasOwnProperty(
          "booking_details_page_title"
        )
          ? (this.pageTitle = this.selectedDepartment.extra.booking_details_page_title)
          : (this.pageTitle = "Booking details title not set");

        // Get the configurable data
        if (this.selectedDepartment.hasOwnProperty("extra")) {
          // Set the extra text on the page to the text taken from the business question

          if (this.adminJourney) {
            this.dataPolicy = `Advise the customer that they can see our Privacy Policy for details on how Essex County Council processes their information. They can find the policy here - <a href="https://www.essex.gov.uk/about-essexgovuk/privacy-and-data-protection/your-privacy" target="_blank">https://www.essex.gov.uk/about-essexgovuk/privacy-and-data-protection/your-privacy</a>.`;
          } else {
            this.selectedDepartment.extra.hasOwnProperty("privacy_statement_text")
              ? (this.dataPolicy = this.selectedDepartment.extra.privacy_statement_text)
              : (this.dataPolicy = "data policy not set");

            this.selectedDepartment.extra.hasOwnProperty("privacy_statement_text_welsh")
              ? (this.dataPolicyCy = this.selectedDepartment.extra.privacy_statement_text_welsh)
              : (this.dataPolicyCy = "Welsh data policy not set");
          }

          if (this.adminJourney) {
            this.tncPolicy = "Registration information is retained indefinitely as required by law. Information collected during the booking of appointments and ceremonies, including certificate orders, is retained for 2 years from the date of the appointment or ceremony.";
          } else {
            this.tncPolicy = "Registration information is retained indefinitely as required by law. Information collected during the booking of appointments and ceremonies, including certificate orders, is retained for 2 years from the date of the appointment or ceremony.";
          }

          if (this.adminJourney) {
            this.servicePolicy = "The Terms and Conditions are available at: <a href='https://www.essex.gov.uk/marriage-or-civil-partnership'target='_blank'>https://www.essex.gov.uk/marriage-or-civil-partnership</a> .  They will also be included in the booking email that will be sent to the customer after the booking process has been completed.  ";
          } else {
            this.servicePolicy = "Please read the Essex Registration Service <a href='https://res.cloudinary.com/bookinglab/image/upload/v1746906911/Essex_Registration_Service_-_Terms_and_Conditions_fk427r.pdf' target='_blank'>Terms and Conditions</a> and confirm you agree.";
          }

          this.selectedDepartment.extra.hasOwnProperty(
            "booking_details_page_text"
          )
            ? (this.bookingDetailsPageText = this.selectedDepartment.extra.booking_details_page_text)
            : null;

          // Set the extra text on the page to the text taken from the business question
          this.selectedDepartment.extra.hasOwnProperty(
            "booking_details_page_text"
          )
            ? (this.bookingDetailsPageText = this.selectedDepartment.extra.booking_details_page_text)
            : null;
          // Get the registration option
          this.selectedDepartment.extra.hasOwnProperty("registration_option")
            ? (registrationOption = this.selectedDepartment.extra
              .registration_option)
            : null;
          // Get the organistion customer questions
          this.selectedDepartment.extra.hasOwnProperty(
            "organisations_questions"
          )
            ? (organisationQuestionsID = this.selectedDepartment.extra
              .organisations_questions)
            : null;

          // If the register option is set to complete a full registration then capture the following details
          if (registrationOption.toLowerCase() === "register complete details") {
            this.requiresFullRegistration = true;
          }
        }

        if (this.datastoreService.customerDetailsForm) {
          Object.keys(this.datastoreService.customerDetailsForm.controls).forEach(key => {
            if (this.customerDetailsForm.controls[key]) {
              this.customerDetailsForm.controls[key].setValue(this.datastoreService.customerDetailsForm.controls[key].value);
            }
          });
        }

        // Use this.departmentService.getLocation() if the services are set on the children departments
        // Use this.departmentService.get() if the services are set on the parent department
        this.departmentService.getLocation().then(async (location) => {
          this.selectedLocation = location;

          this.memberService.getMember().then((member) => {
            this.member = member;

            // Get the customer questions
            this.departmentService.getCustomerQuestions().then((questions) => {
              const filteredQuestions = []
              for (let index = 0; index < questions.length; index++) {
                const question = this.customerQuestions[index];
                filteredQuestions.push(question)
                question.visible = false;
                question.reference = question.id;
                if (!question.admin_only) {
                  if (!question.settings.hasOwnProperty('conditional_question')) {
                    question.visible = true;
                  }

                  const questionControl = question.id;
                  if (question.detail_type == 'check' || question.detail_type == 'check-price') {
                    if (question.default == 1) {
                      if (question.required) {
                        this.customerDetailsForm.addControl(questionControl, new UntypedFormControl(true, Validators.requiredTrue));
                      } else {
                        this.customerDetailsForm.addControl(questionControl, new UntypedFormControl(true));
                      }
                    } else {
                      if (question.required) {
                        this.customerDetailsForm.addControl(questionControl, new UntypedFormControl('', Validators.requiredTrue));
                      } else {
                        this.customerDetailsForm.addControl(questionControl, new UntypedFormControl(false));
                      }
                    }
                  } else {
                    // Need to add the control for display purposes but we don't need to validate it as we've added three new controls.
                    if (question.id !== 1 && question.id !== 279 && question.id !== 34) {
                      if (question.required) {
                        this.customerDetailsForm.addControl(questionControl, new UntypedFormControl('', Validators.required));
                      } else {
                        this.customerDetailsForm.addControl(questionControl, new UntypedFormControl(''));
                      }
                    }
                    else {
                      this.customerDetailsForm.addControl(questionControl, new UntypedFormControl(''));
                    }
                  }
                }
                // }
              }
              this.customerQuestions = filteredQuestions;
              this.datastoreService.customerQuestions = filteredQuestions;
              this.dateId = "";
              // id of date question is one of these, but we don't know which
              if (this.customerDetailsForm.get("1") !== undefined) this.dateId = "1";
              if (this.customerDetailsForm.get("279") !== undefined) this.dateId = "279";
              if (this.customerDetailsForm.get("34") !== undefined) this.dateId = "34";
            });
          });
          this.spinner.hide();
        });

        // Get the selected service
        this.servicesService.get().then(async (service) => {
          this.selectedService = service;

          // Get the questions
          const res = await this.selectedService.$get("questions");
          this.datastoreService.bookingQuestions = res.questions;
          this.addQuestionsToForm(res.questions)
          // const questions = []
          // const sortedQuestions = res.questions;
          // for (let index = 0; index < res.questions.length; index++) {
          //   // ignore the previously asked questions
          //   const question = sortedQuestions[index];
          //   if ((this.config['first_page_questions_to_ignore'].includes(question.id))) {
          //     questions.push(question)
          //     if (![275, 276, 277, 278].includes(question.id)) {
          //       question.visible = false;
          //       question.reference = question.id;
          //       if (!question.admin_only) {
          //         if (!question.settings.hasOwnProperty("conditional_question")) {
          //           question.visible = true;
          //         }
          //         const questionControl = question.id;

          //         if (question.detail_type == 'check' || question.detail_type == 'check-price') {
          //           if (question.required) {
          //             this.bookingQuestionsForm.addControl(questionControl, new FormControl(false, Validators.requiredTrue));
          //           } else {
          //             this.bookingQuestionsForm.addControl(questionControl, new FormControl(false));
          //           }
          //         } else {
          //           if (question.required) {
          //             this.bookingQuestionsForm.addControl(questionControl, new FormControl('', Validators.required));
          //           } else {
          //             this.bookingQuestionsForm.addControl(questionControl, new FormControl(''));
          //           }
          //         }
          //       }
          //     }
          //   }
          // }
        });
      }
    });
  }

  ngAfterViewInit(): void {
    new PasswordInput(this.passwordCtrl.nativeElement);
  }

  async radioCopyChange() {
    const status = this.customerDetailsForm.value.copyData
    if (this.datastoreService.config.journey_config.copyClientDetails) {
      const copyClientDetails = this.datastoreService.config.journey_config.copyClientDetails
      if (status === "Yes") {
        for (let i in copyClientDetails.from) {
          this.companyQuestionsForm.controls[copyClientDetails.to[i].toString()].setValue(this.customerDetailsForm.value[copyClientDetails.from[i]])
        }
      } else {
        for (let i in copyClientDetails.to) {
          this.companyQuestionsForm.controls[
            copyClientDetails.to[i].toString()
          ]?.setValue("");
        }
      }
    }
  }

  addHyperlinks(question) {
    let linkPattern = /#(.*?)#/g;
    if (linkPattern.test(question.conditionals.component_text)) {
      // replace the #link# with a hyperlink
      question.conditionals.component_text = question.conditionals.component_text.replace(linkPattern, function (match, p1) {
        return `<a href="${question.conditionals.hyperlink}" target="_blank">` + p1 + '</a>';
      });
    }
    return question.conditionals.component_text;
  }


  onQuestionChange() {
    // this.showServices = false;
    this.datastoreService.extraDuration = 0; // reset or we add more on everytime
    if (!this.companyQuestions) {
      return;
    }
    const bookingQuestions = this.companyQuestions;
    // Conditional questions logic
    // for (let index = 0; index < bookingQuestions.length; index++) {
    bookingQuestions.forEach(async (bookingQuestion: any) => {
      bookingQuestion.visible = false; // reset any questions that shouldnt be visible
      // go get the answer for every question from the form
      let control = this.companyQuestionsForm.get(`${bookingQuestion.id}`);
      bookingQuestion.answer = undefined;
      if (control) {
        // set booking question from form values
        bookingQuestion.answer = control.value ? control.value : undefined;
      }

      if (bookingQuestion["help_text"]) {
        bookingQuestion.conditionals = JSON.parse(bookingQuestion["help_text"]); // to change to settings block soon
        if (bookingQuestion.conditionals.hasOwnProperty('help_text')) {
          bookingQuestion.helptext = bookingQuestion.conditionals.help_text;
          let linkPattern = /#(.*?)#/g;
          if (linkPattern.test(bookingQuestion.helptext)) {
            bookingQuestion.helptext = bookingQuestion.helptext.replace(linkPattern, function (match, p1) {
              return `<a href="${bookingQuestion.conditionals.hyperlink}" target="_blank">` + p1 + '</a>';
            });
          }
        }
        if (bookingQuestion.conditionals.hasOwnProperty('question-font-colour')) {
          bookingQuestion.customLabelColour = bookingQuestion.conditionals['question-font-colour'];
        }
        if (bookingQuestion.conditionals.hasOwnProperty('address_lookup')) {
          if (bookingQuestion.conditionals['address_lookup'] === 'yes') {
            bookingQuestion.address_lookup = true
          }
        }

        if (bookingQuestion.conditionals.hasOwnProperty('address_lookup_multi_line')) {
          bookingQuestion.address_lookup_multi_line = true;
          bookingQuestion.address_lookup_multi_line_to = bookingQuestion.conditionals.address_lookup_multi_line.to;
        }
        if (bookingQuestion.conditionals.hasOwnProperty('validation')) {
          if (!this.config.validation) {
            // if there is no validation on the root
            // its probably under the journey_config
            this.config.validation =
              this.config.journey_config?.appointments?.validation;
          }
          if (this.config.validation[bookingQuestion.conditionals.validation]) {
            bookingQuestion.validation = this.config.validation[bookingQuestion.conditionals.validation];
            bookingQuestion.validation_message = bookingQuestion.conditionals.validation_message;
            let validators = [Validators.pattern(bookingQuestion.validation)];
            if (bookingQuestion.required) {
              validators.push(Validators.required);
            }
            control.setValidators(validators);
            this.companyQuestionsForm.updateValueAndValidity();
          }
          else {
            if (bookingQuestion.conditionals.validation == 'email') {
              bookingQuestion.validation = 'email';
              bookingQuestion.validation_message = bookingQuestion.conditionals.validation_message;
              let validators = [Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i)];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              control.setValidators(validators);
              this.companyQuestionsForm.updateValueAndValidity();
            }
          }
        } else {
          if (bookingQuestion.required) {
            control.setValidators(Validators.required);
          }
        }
        if (bookingQuestion.conditionals.hasOwnProperty('section_title')) {
          if (bookingQuestion.conditionals.section_title) {
            bookingQuestion.detail_type = "heading_2";
          }
        }

        if (bookingQuestion.detail_type === 'date') {
          bookingQuestion.hide_dates_in_future = false;
          bookingQuestion.hide_dates_in_past = false;

          if (bookingQuestion.conditionals.hasOwnProperty('hide_dates_in_future') && bookingQuestion.conditionals.hide_dates_in_future) {
            bookingQuestion.hide_dates_in_future = moment().format('YYYY-MM-DD');
            // future date
            if (bookingQuestion.hide_dates_in_future) {
              let validators = [];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              validators.push(this.futureDateValidator);
              control.setValidators(validators);
              control.updateValueAndValidity();
              console.log(validators);
              this.companyQuestionsForm.updateValueAndValidity();
            }
          }

          if (bookingQuestion.conditionals.hasOwnProperty('hide_dates_in_past') && bookingQuestion.conditionals.hide_dates_in_past) {
            bookingQuestion.hide_dates_in_past = moment().format('YYYY-MM-DD');

            // past date
            if (bookingQuestion.hide_dates_in_past) {
              let validators = [];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              validators.push(this.pastDateValidator);
              control.setValidators(validators);
              control.updateValueAndValidity();
              this.companyQuestionsForm.updateValueAndValidity();
            }
          }
        }

        let conditionals = bookingQuestion.conditionals;
        let show = conditionals.show;
        let hide = conditionals.hide;
        let admin_show = conditionals.admin_show;
        let admin_only = conditionals.admin_only;
        let custom = conditionals.custom;

        // if the booking is only for the admin journey
        if (admin_only && this.datastoreService.adminJourney) {
          show = admin_show;
          admin_only = false;
        }

        if (Object.keys(show).length === 0 && Object.keys(hide).length === 0 && !conditionals.admin_only) {
          // no hide or show conditional values, just show the question by default
          bookingQuestion.visible = true;
        }

        // show condition loop
        for (const answerId in show) {
          if (answerId == 'hide') {
            return; // this shouldnt happen only if the setup is wrong
          }
          if (answerId == 'custom') {
            // custom conditionals to go here
            let conditionalQuestion = this.companyQuestionsForm.get(`${Object.keys(show[answerId])[0]}`);
            if (conditionalQuestion && conditionalQuestion.value != null) {
              if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
                let condition: any = Object.values(show[answerId])[0];
                if (condition.includes('OR')) {
                  if (this.evaluateORCondition(condition, conditionalQuestion.value)) {
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (this.evaluateCondition(condition, conditionalQuestion.value)) {
                    bookingQuestion.visible = true;
                  }
                }
              }
            }
          } else {
            // if this is an admin journey, and there is an admin show value
            if (this.datastoreService.adminJourney && admin_show) {
              // if we find a show in both
              if (admin_show[`${answerId}`] && show[`${answerId}`]) {
                // set the show to the admin version as it supersedes show
                show[`${answerId}`] = admin_show[`${answerId}`];
                bookingQuestion.admin_override = true;
              }
            }

            let conditionalQuestion = this.companyQuestionsForm.get(`${answerId}`);
            if (!conditionalQuestion && show) {
              // console.log(`conditional question is null but has a show value`);
              conditionalQuestion = this.datastoreService.startQuestions.get(`${answerId}`);
            }

            if (conditionalQuestion && conditionalQuestion.value != null) {
              if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
                if (show[answerId].trim() == "*") { // wild card
                  if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) { // if there is any answer
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (`${conditionalQuestion.value}` == `${show[answerId]}`) {
                    bookingQuestion.visible = true;
                  }
                }
              }
            }
          }
        }

        // perform hide after show because we want it to take priority
        for (const answerId in hide) {
          if (answerId == 'show') {
            return; // this shouldnt happen only if the setup is wrong
          }
          if (answerId == 'custom') {
            let conditionalQuestion = this.companyQuestionsForm.get(`${Object.keys(hide[answerId])[0]}`);
            if (conditionalQuestion && conditionalQuestion.value != null) {
              if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
                let condition: any = Object.values(hide[answerId])[0];
                if (condition.includes('OR')) {
                  if (this.evaluateORCondition(condition, conditionalQuestion.value)) {
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (this.evaluateCondition(condition, conditionalQuestion.value)) {
                    bookingQuestion.visible = true;
                  }
                }
              }
            }
          } else {
            console.log(`${answerId}`);
            let conditionalQuestion = this.companyQuestionsForm.get(`${answerId}`);
            if (conditionalQuestion && conditionalQuestion.value != null) {
              if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
                if (show[answerId] == "*") { // wild card
                  if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) { // if there is any answer
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (`${conditionalQuestion.value}` == `${show[answerId]}`) {
                    bookingQuestion.visible = false;
                  }
                }
              }
            }
          }
        }

        // copy question schema
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('copy_data')) {
            bookingQuestion.copy_data_from = bookingQuestion.conditionals['copy_data'].from;
            bookingQuestion.copy_data_to = bookingQuestion.conditionals['copy_data'].to;
            bookingQuestion.copy_answer = bookingQuestion.conditionals['copy_data'].answer;

            if (bookingQuestion.answer == true || bookingQuestion.copy_answer == bookingQuestion.answer) {
              bookingQuestion.copy_data_from.forEach((fromId, index) => {
                const toId = bookingQuestion.copy_data_to[index];
                const sourceControl = this.companyQuestionsForm.get(String(fromId));
                const targetControl = this.companyQuestionsForm.get(String(toId));
                if (sourceControl && targetControl) {
                  targetControl.setValue(sourceControl.value);
                } else {
                  console.warn(`Control not found for: ${fromId} or target: ${toId}`);
                }
              });
            }
            // commented out because we cant clear the fields if there is no answer because 
            // the field will be cleard everytime the user changes an answer but hasnt filled in the copy question
            // else {
            //   // clear all the copy_data_to fields
            //   bookingQuestion.copy_data_to.forEach((toId) => {
            //     const targetControl = this.companyQuestionsForm.get(String(toId));
            //     if (targetControl) {
            //       targetControl.setValue('');
            //     }
            //   });
            // }
          }
        }

        // add hidden field
        if (bookingQuestion.conditionals.hasOwnProperty('hidden_field')) {
          bookingQuestion.hidden = true;
        }

        // add duration schema 
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('add_duration')) {
            this.datastoreService.extraDuration = (Number(this.datastoreService.extraDuration) + Number(bookingQuestion.conditionals.add_duration));
          }
        }

        // set sevice question to var
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('service_set')) {
            this.datastoreService.setService = bookingQuestion.conditionals.service_set;
          }
        }

        // extra booking fee item
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('extra-item')) {
            bookingQuestion.extraItem = bookingQuestion.conditionals['extra-item'];
            bookingQuestion.extraItemLabel = bookingQuestion.conditionals['extra-item-label'];
            bookingQuestion.payment_code = bookingQuestion.conditionals['payment_code'];

            // get unix time
            const unixTime = moment().unix();
            if (bookingQuestion.unixTime == unixTime) {
              return;
            } else {
              bookingQuestion.unixTime = unixTime;
            }

            if (bookingQuestion.answer) {
              const itemProps: any = await this.apiService.getExtraItemProperties(bookingQuestion.extraItem, this.selectedDepartment.id, this.selectedService.id)
              if (itemProps) {
                bookingQuestion.current_price = itemProps.item_price;
              }

              // const cost = bookingQuestion.options.filter(option => option.name == bookingQuestion.answer);
              const costVar = itemProps.item_price;
              // find the fees first
              const foundItem = this.costBreakDown.find((f) => f.questionid === bookingQuestion.id && f.item === bookingQuestion.extraItemLabel && f.payment_code === bookingQuestion.payment_code);

              // if found item exists, get its id and remove any item from the costbreakdown with that id
              if (foundItem) {
                const foundItemId = foundItem.id;
                this.costBreakDown = this.costBreakDown.filter((f) => f.id !== foundItemId);
              }

              this.costBreakDown.push({
                questionid: bookingQuestion.id,
                item: bookingQuestion.extraItemLabel,
                quantity: bookingQuestion.answer,
                cost: costVar,
                payment_code: bookingQuestion.payment_code
              });
              this.datastoreService.triggerAddFees({
                questionid: bookingQuestion.id,
                item: bookingQuestion.extraItemLabel,
                quantity: bookingQuestion.answer,
                cost: costVar,
                payment_code: bookingQuestion.payment_code
              });

            }
          }
        }

        // set client data on booking details page
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('booker_first_name')) {
            this.datastoreService.booker_first_name = bookingQuestion.id;
          }
          if (bookingQuestion.conditionals.hasOwnProperty('booker_last_name')) {
            this.datastoreService.booker_last_name = bookingQuestion.id;
          }
          if (bookingQuestion.conditionals.hasOwnProperty('booker_email')) {
            this.datastoreService.booker_email = bookingQuestion.id;
          }
          if (bookingQuestion.conditionals.hasOwnProperty('booker_phone')) {
            this.datastoreService.booker_phone = bookingQuestion.id;
          }
        }

        // if (bookingQuestion.conditionals.hasOwnProperty('continuebutton')) {
        //   // showContinueButton
        //   let conditionalQuestion = this.companyQuestionsForm.get(`${Object.keys(bookingQuestion.conditionals.continuebutton)[0]}`);
        //   console.log(conditionalQuestion);
        //   if (conditionalQuestion && conditionalQuestion.value != null) {
        //     if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
        //       if (Object.values(bookingQuestion.conditionals.continuebutton)[0][0] == "*") { // wildcard
        //         if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
        //           if (this.config["auto_select_service"]) {
        //             this.showContinueButton = true;
        //           } else {
        //             // filter services
        //             if (this.datastoreService.setService) {
        //               this.filteredServiceList = this.servicesList.filter(service => `${service.id}` == `${this.datastoreService.setService}`);
        //             } else {
        //               this.filteredServiceList = this.servicesList;
        //             }
        //             // this.showServices = true;
        //           }
        //         }
        //       } else {
        //         if (conditionalQuestion.value == Object.values(bookingQuestion.conditionals.continuebutton)[0][0]) {
        //           if (this.config["auto_select_service"]) {
        //             this.showContinueButton = true;
        //           } else {
        //             // filter services
        //             if (this.datastoreService.setService) {
        //               this.filteredServiceList = this.servicesList.filter(service => `${service.id}` == `${this.datastoreService.setService}`);
        //             } else {
        //               this.filteredServiceList = this.servicesList;
        //             }
        //             // this.showServices = true;
        //           }
        //         }
        //       }
        //     }
        //   }
        // }

        // slice booking questions off for first-n
        if (bookingQuestion.visible && !bookingQuestion.optionsRemoved) {
          if (bookingQuestion.conditionals.hasOwnProperty('remove-options-customer')) {
            let firstN = bookingQuestion.conditionals['remove-options-customer']['first-n'];
            if (!this.datastoreService.adminJourney) {
              bookingQuestion.options = bookingQuestion.options.slice(firstN);
              bookingQuestion.optionsRemoved = true;
            }
          }
        }

        if (!this.datastoreService.adminJourney && admin_only) {
          bookingQuestion.visible = false;
        }

        if (!bookingQuestion.visible) {
          let conditionalQuestion = this.companyQuestionsForm.get(`${bookingQuestion.id}`);
          conditionalQuestion.reset();
          conditionalQuestion.clearValidators();
          conditionalQuestion.updateValueAndValidity();
        }
      } else {
        bookingQuestion.visible = true;
      }
    });
  }

  evaluateORCondition(condition, answer) {
    const parts = condition.split(' OR ');

    let evaluation = [];
    // Evaluate each part of the condition
    for (const part of parts) {
      if (part == answer) {
        evaluation.push(true);
      } else {
        evaluation.push(false);
      }
    }

    console.log(evaluation);
    let evalArray = evaluation.some(element => element === true);
    // If evaluation has a true, one of the values is correct so it will return true
    return evalArray;
  }

  // Function to evaluate custom condition
  evaluateCondition(condition, answer) {

    // Split the condition into individual parts
    const parts = condition.split(' and ');

    // Evaluate each part of the condition
    for (const part of parts) {
      // Split the part into operator and threshold
      let [operator, thresholdStr] = part.split(' ');
      const threshold = parseFloat(thresholdStr);

      // decode html entity
      operator = he.decode(operator);

      if (this.isValidDate(answer)) {
        answer = (moment(answer).diff(moment(), 'days') + 1);
      }

      // Perform the comparison based on the operator
      switch (operator) {
        case '<':
          if (!(parseFloat(answer) < threshold)) {
            return false; // If any part is false, the entire condition is false
          }
          break;
        case '<=':
          if (!(parseFloat(answer) <= threshold)) {
            return false;
          }
          break;
        case '>':
          if (!(parseFloat(answer) > threshold)) {
            return false;
          }
          break;
        case '>=':
          if (!(parseFloat(answer) >= threshold)) {
            return false;
          }
          break;
        case '=':
          if (!(parseFloat(answer) === threshold)) {
            return false;
          }
          break;
        default:
          return false;
      }
    }

    // If all parts pass, return true
    return true;
  }

  validateQuestions(event, question) {
    // Extract the day, month, and year values from the inputs
    const dayInput = (document.getElementById(`${question.id}_d`) as HTMLInputElement)?.value;
    const monthInput = (document.getElementById(`${question.id}_m`) as HTMLInputElement)?.value;
    const yearInput = (document.getElementById(`${question.id}_y`) as HTMLInputElement)?.value;

    // Combine them into a single date string
    const day = dayInput?.padStart(2, '0'); // Ensure day is two digits
    const month = monthInput?.padStart(2, '0'); // Ensure month is two digits
    const year = yearInput; // Year doesn't need padding

    // Validate that the inputs are valid and combine into a date
    if (day && month && year) {
      this.companyQuestionsForm.controls[question.reference].markAsTouched();
      this.companyQuestionsForm.controls[question.reference].markAsDirty();
      const combinedDate = `${year}-${month}-${day}`; // Format: YYYY-MM-DD
      if (this.isValidDateQuestion(combinedDate)) {
        console.log(combinedDate);
        this.companyQuestionsForm.controls[question.reference].setValue(combinedDate);
        console.log(this.companyQuestionsForm);
      } else {
        console.error('Invalid date entered:', combinedDate);
        // question.selectedDate = null; // Clear selectedDate if invalid
      }
    } else {
      question.selectedDate = null; // Clear selectedDate if not all fields are filled
    }

    // this.calculateVisibility();
    this.onQuestionChange();
  }

  isValidDateQuestion(dateString: string): boolean {
    const date = new Date(dateString);
    return !isNaN(date.getTime()); // Check if the date is valid
  }

  updateRadio(form, question, answer) {
    console.log(form, question, answer)
    form.controls[question].setValue(answer)
    if (question !== 'copyData') {
      this.onQuestionChange()
    } else {
      this.radioCopyChange()
    }
  }

  setAddress(event, question) {
    // set the address value on the form
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value; // This now gives you `option.id`
    console.log('Selected Value:', selectedValue);
    this.companyQuestionsForm.controls[question.reference].setValue(selectedValue);
    console.log(this.companyQuestionsForm);
  }

  getAddress(question) {
    question.currently_searching = true;
    // Custom error handling for postcode
    try {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(async () => {
        let postcode: string = this.companyQuestionsForm.controls["postcode_" + question.reference].value.replace(/\s/g, '');
        if (postcode.length > 1) {
          //check postcode accepts regex before calling
          if (this.postcodeValidator.test(postcode)) {
            this.apiService.get(postcode).subscribe(
              (res) => {
                this.companyQuestionsForm.controls[`postcode_${question.id}`].setErrors({ invalid_address: false });
                var object: any = res;
                if (object.results) {
                  var addresses = object.results;
                  question.addresses = [];
                  if (addresses.length > 1) {
                    // If it matches up, push the addresses
                    addresses.forEach((item) => {
                      if (item.DPA) {
                        item.DPA.type = 'DPA';
                        question.addresses.push({ address: item.DPA });
                      } else {
                        item.LPI.type = 'LPI';
                        question.addresses.push({ address: item.LPI });
                      }
                    });
                  }
                }
                this.spinner.hide();
              },
              (err) => {
                console.log(err);
                this.spinner.hide();
              }
            );
          } else {
            this.companyQuestionsForm.controls[`postcode_${question.id}`].setErrors({ invalid_address: true });
          }
        }
      }, 500);
    } catch (error) {
      console.log(error);
    }
  }

  onFileChange(event, questionId) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.form[questionId].setValue(file, { emitModelToViewChange: false });
      this.bookingQuestionsForm.patchValue({
        fileSource: file,
      });
    }
  }

  isValidDate(dateString: string): boolean {
    // Attempt to create a Date object from the dateString
    const date: Date = new Date(dateString);
    // Check if the created Date object is valid and its string representation matches the input
    return date instanceof Date && !isNaN(date.getTime()) && date.toISOString().slice(0, 10) === dateString;
  }

  getAge(dateString): Number {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  // validate future dates
  futureDateValidator(control) {
    const currentDate = new Date();
    const inputDate = new Date(control.value);
    if (control.value) {
      if (inputDate > currentDate) {
        return { futureDate: true };
      }
      return null;
    } else {
      return null;
    }
  }

  // validate past dates
  pastDateValidator(control) {
    const currentDate = new Date();
    const inputDate = new Date(control.value);
    if (control.value) {
      if (inputDate < currentDate) {
        return { pastDate: true };
      }
      return null;
    } else {
      return null;
    }
  }

  async onSubmit() {
    this.spinner.show();
    this.submitted = true;
    this.alertService.clear();

    // Check if form is valid
    // console.log(this.customerDetailsForm.invalid || this.bookingQuestionsForm.invalid)

    Object.keys(this.companyQuestionsForm.controls).forEach((key) => {
      const control = this.companyQuestionsForm.controls[key];
      //clear postcode validation for postcode search as it will prevent submission on non-mandatory field
      if (key.startsWith("postcode_")) {
        control.setErrors(null);
      }
    });

    // trigger form validation    
    this.customerDetailsForm.markAllAsTouched();
    this.companyQuestionsForm.markAllAsTouched();

    // trigger the validation on the customerDetailsForm 
    this.customerQuestions.forEach((question) => {
      this.customerDetailsForm.controls[question.id].markAsTouched();
    });

    if (this.adminJourney) {
      if (this.customerDetailsForm.value.email_address_consent == false || this.customerDetailsForm.value.contact_number_consent == false) {
        this.scrollToTop();
        this.spinner.hide();
        this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
        return;
      }
    } else {
      this.customerDetailsForm.controls.email_address_consent.setValue(true);
      this.customerDetailsForm.controls.contact_number_consent.setValue(true);
      this.customerDetailsForm.controls.email_address_consent.setErrors(null);
      this.customerDetailsForm.controls.contact_number_consent.setErrors(null);
    }

    if (this.customerDetailsForm.invalid || this.companyQuestionsForm.invalid) {
      this.scrollToTop();
      this.spinner.hide();
      this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
      return;
    }

    // var currentDate = new Date(this.slot.start);
    // await this.apiService.checkForDoubleBooking(
    //   this.selectedDepartment,
    //   currentDate,
    //   this.customerDetailsForm.value.email_address ? this.customerDetailsForm.value.email_address : null,
    //   this.customerDetailsForm.value.mobile_number ? this.customerDetailsForm.value.mobile_number : null,
    // ).then((res: []) => {
    //   // res = array of unavailable times
    //   this.unavailableTimes = res

    this.completeBooking()
    // })
  }

  async completeBooking() {
    // this.bookingQuestionsForm.controls.contact(this.datastoreService.startQuestions)
    this.datastoreService.bookingForm = this.bookingQuestionsForm;
    this.datastoreService.companyAnswers = this.companyQuestionsForm;

    this.datastoreService.customerDetailsForm = this.customerDetailsForm;
    this.spinner.hide();

    this.router.navigate(["/summary"]);
  }

  // Scroll to the top of the page
  scrollToTop() {
    const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
    window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
  }

  // Number input text validation, keycode 8 is backspacev
  keyPressNumberField(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    const inputElement = event.target as HTMLInputElement;
    if (event.keyCode != 8 && !pattern.test(inputChar) || inputElement.value.length >= 13) {
      event.preventDefault();
    }
  }

  calculateCertificates(question) {
    let optionChosen = question.options.find((x) => x.name.toString() === this.bookingForm[question.id].value.toString());
    const foundOption = this.costBreakDown.find((f) => f.cost === optionChosen.price && f.quantity === optionChosen.name);
    console.log('foundOption', foundOption);
    if (!foundOption) {
      this.costBreakDown.push({
        item: "Certificates",
        quantity: optionChosen.name,
        cost: optionChosen.price
      });

      this.datastoreService.costBreakDown = this.costBreakDown;
    }
  }

  addQuestionsToForm(questions) {
    this.companyQuestions = [];
    this.companyQuestionsForm = this.formBuilder.group({});
    for (let index = 0; index < questions.length; index++) {
      const question = questions[index];
      question.visible = false;
      question.reference = question.id;
      if (!question.admin_only) {
        if (!question.settings.hasOwnProperty("conditional_question")) {
          question.visible = false; // default hidden all
        }

        const questionControl = question.id;

        if (!question["help_text"]) { // question without any config
          question.conditionals = {
            page: this.router.url, // show on current page
          };
        } else {
          question.conditionals = JSON.parse(question["help_text"]);
        }

        if (question.conditionals.page == this.router.url.replace("/", "")) {
          this.companyQuestions.push(question);

          let validators = [];

          // required validator
          if (question.required) {
            validators.push(Validators.required);
          }
          if (question.conditionals['address_lookup'] || question.conditionals['address_lookup_multi_line']) {
            this.companyQuestionsForm.addControl("postcode_" + questionControl, new UntypedFormControl((''), validators));
          }
          if (question.detail_type == 'check' || question.detail_type == 'check-price') {
            this.companyQuestionsForm.addControl(questionControl, new UntypedFormControl('', Validators.requiredTrue));
          } else {
            this.companyQuestionsForm.addControl(questionControl, new UntypedFormControl((''), validators));
          }

          // if we can find that question on datastore, we can set value back to what we have saved
          if (this.datastoreService.companyAnswers) {
            let questionFound = this.datastoreService.companyAnswers.get(`${question.id}`);
            if (questionFound) {
              this.companyQuestionsForm.controls[question.id].setValue(questionFound.value);
              this.companyQuestionsForm.controls[question.id].patchValue(questionFound.value);
            }
          }

          // once the controls are added we can set the default values
          if (question.detail_type == "select" || question.detail_type == "select-price") {
            if (question.conditionals.hasOwnProperty('default')) {
              const defaultOption = question.options.find(option => option.name == question.conditionals.default);
              if (defaultOption) {
                this.companyQuestionsForm.controls[question.id].setValue(defaultOption.name.trim());
                this.companyQuestionsForm.controls[question.id].updateValueAndValidity();
                this.cdref.markForCheck();
                this.calculateCertificates(question);
              }
            }
            // const defaultOption = question.options.find(option => option.is_default);
            // if (defaultOption) {
            //   this.companyQuestionsForm.controls[question.id].setValue(defaultOption.name);
            //   this.companyQuestionsForm.controls[question.id].patchValue(defaultOption.name);
            //   this.calculateCertificates(question);
            // }
          }

        } else {
          // console.log(`skipped ${question.id}`); // debugging remove later
        }
      }
    }
    this.onQuestionChange();
  }

  selectSuggestion(selectedUPRN: any, question: any): void {
    const suggestion = question.addresses.find(
      (option) => option.address.UPRN === selectedUPRN
    );
    question.addresses = [];
    question.currently_searching = false;
    if (question.address_lookup_multi_line) {
      let address = suggestion['address'];
      let multiline = question.address_lookup_multi_line_to;
      if (address.type = "DPA") {
				const keys = ['BUILDING_NUMBER', 'BUILDING_NAME', 'ORGANISATION_NAME'];
				const selectedValue = keys.find((key) => address[key] !== undefined)
					? address[keys.find((key) => address[key] !== undefined)]
					: null;
				this.companyQuestionsForm.controls[multiline[0]].setValue(
					`${selectedValue ?? ''} ${address?.THOROUGHFARE_NAME ?? ''}`
				); // address 1
				this.companyQuestionsForm.controls[multiline[1]].setValue(
					address?.DEPENDENT_LOCALITY ?? ''
				);

				this.companyQuestionsForm.controls[multiline[3]].setValue(
					address?.POST_TOWN ?? ''
				); // address 4
				this.companyQuestionsForm.controls[multiline[4]].setValue(
					address?.POSTCODE ?? ''
				); // address 5
			} else {
        this.companyQuestionsForm.controls[multiline[0]].setValue(`${address.PAO_START_NUMBER ?? ''} ${address.STREET_DESCRIPTION ?? ''} ${address.SAO_TEXT ?? ''}`); // address 1
        this.companyQuestionsForm.controls[multiline[1]].setValue(`${address.LOCALITY_NAME ?? ''} ${address.PAO_TEXT ?? ''}`); // address 2
        this.companyQuestionsForm.controls[multiline[2]].setValue(`${address.TOWN_NAME ?? ''}`); // address 3
        this.companyQuestionsForm.controls[multiline[3]].setValue(`${address.ADMINISTRATIVE_AREA ?? ''}`); // address 4
        this.companyQuestionsForm.controls[multiline[4]].setValue(`${address.POSTCODE ?? ''}`); // address 5
      }
      this.onQuestionChange();
    } else {
      // code for single line addresses can go here
      this.companyQuestionsForm.controls[question.id].setValue(suggestion['pretty_name']);
      this.companyQuestionsForm.controls[question.id].updateValueAndValidity();
      this.onQuestionChange();
    }
  }

}
